import { provideConfig, RoutingConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { JobSearchPagesModule } from './job-search-pages/job-search-pages.module'

@NgModule({
  imports: [
    JobSearchPagesModule
  ],
  providers: [
    provideConfig({
      routing: {
        routes: {
          jobs: {
            paths: ['about-us/careers/open-positions/job-details/show']
          },
          jobDetailPage: {
            paths: ['about-us/careers/open-positions/job-details/show/:id'],
            paramsMapping: { id: 'id' }
          }
        }
      }
    } as RoutingConfig)
  ]
})
export class JobSearchRootModule {
}
